<wk-icon-filled-clock-sprite-pds3 />

<wk-settings-breadcrumb (breadcrumbNavigate)="onBreadcrumbNavigate($event)" />
<div class="wk-sg__header">
    <div class="wk-sg__title wk-sg__header-title">{{ "Settings.GeneralSettings" | translate }}</div>
    <wk-dashboard-select [showDashboardRenameOption]="true" (canChangeDashboard)="canChangeDashboard($event)" />
</div>

@if (groupSettingForm != null) {
    <div class="wk-sg__content">
        <form [formGroup]="groupSettingForm" class="wk-sg__form">
            <div class="wk-sg__section">
                <div class="wk-sg__title">{{ "Settings.Preferences" | translate }}</div>
                <div class="wk-sg__section-container">
                    <div class="wk-sg__section-container__inputs">
                        <div class="wk-sg__section-container__inputs__group">
                            <div class="wk-sg__section-container__inputs__group-title">{{ "Settings.PreferencesLabel2_New" | translate }}</div>
                            <div class="wk-sg__input">
                                <icon-pds3 name="wk-icon-filled-clock" class="warning wk-sg__input-icon" />
                                <div class="wk-sg__input-label">{{ "Settings.Warning" | translate }}</div>
                                <input
                                    formControlName="DaysInStepWarning"
                                    id="DaysInStep_warning"
                                    type="number"
                                    min="0"
                                    max="999"
                                    class="form-control wk-sg__input-number"
                                    (input)="numberInput($event)"
                                    (blur)="checkValidation()"
                                />

                                @if (groupSettingForm.controls.DaysInStepWarning.invalid) {
                                    <tooltip-pds3
                                        elementId="NumberOfDaysWarningShouldLess"
                                        mode="description"
                                        [openDelay]="250"
                                        [closeDelay]="250"
                                        position="left"
                                        targetSelector="#DaysInStep_warning"
                                        class="danger"
                                    >
                                        {{ "Settings.NumberOfDaysWarningShouldLess" | translate }}
                                    </tooltip-pds3>
                                }
                            </div>
                            <div class="wk-sg__input">
                                <icon-pds3 name="wk-icon-filled-clock" class="danger wk-sg__input-icon" />
                                <div class="wk-sg__input-label">{{ "Settings.Danger" | translate }}</div>
                                <input
                                    formControlName="DaysInStepAlert"
                                    id="DaysInStep_alert"
                                    type="number"
                                    min="0"
                                    max="999"
                                    class="form-control wk-sg__input-number"
                                    (input)="numberInput($event)"
                                    (blur)="checkValidation()"
                                />

                                @if (groupSettingForm.controls.DaysInStepAlert.invalid) {
                                    <tooltip-pds3
                                        elementId="NumberOfDaysAlertShouldLess"
                                        mode="description"
                                        [openDelay]="250"
                                        [closeDelay]="250"
                                        position="left"
                                        targetSelector="#DaysInStep_alert"
                                        class="danger"
                                    >
                                        {{ "Settings.NumberOfDaysWarningShouldLess" | translate }}
                                    </tooltip-pds3>
                                }
                            </div>
                        </div>
                        <div class="wk-sg__section-container__inputs__group">
                            <div class="wk-sg__section-container__inputs__group-title">
                                @if (isJobsBillingDashboard === true) {
                                    {{ "Settings.PreferencesLabel4_JobsAndBilling" | translate }}
                                } @else {
                                    {{ "Settings.PreferencesLabel4_New" | translate }}
                                }
                            </div>
                            <div class="wk-sg__input">
                                <icon-pds3 name="wk-icon-filled-clock" class="warning wk-sg__input-icon" />
                                <div class="wk-sg__input-label">{{ "Settings.Warning" | translate }}</div>
                                <input
                                    formControlName="DaysBeforeDeadlineWarning"
                                    id="DaysBeforeDeadline_warning"
                                    type="number"
                                    min="0"
                                    max="999"
                                    class="form-control wk-sg__input-number"
                                    (input)="numberInput($event)"
                                    (blur)="checkValidation()"
                                />

                                @if (groupSettingForm.controls.DaysBeforeDeadlineWarning.invalid) {
                                    <tooltip-pds3
                                        elementId="NumberOfDaysWarningShouldGreate_warning"
                                        mode="description"
                                        [openDelay]="250"
                                        [closeDelay]="250"
                                        position="left"
                                        targetSelector="#DaysBeforeDeadline_warning"
                                        class="danger"
                                    >
                                        {{ "Settings.NumberOfDaysWarningShouldGreate" | translate }}
                                    </tooltip-pds3>
                                }
                            </div>
                            <div class="wk-sg__input">
                                <icon-pds3 name="wk-icon-filled-clock" class="danger wk-sg__input-icon" />
                                <div class="wk-sg__input-label">{{ "Settings.Danger" | translate }}</div>
                                <input
                                    formControlName="DaysBeforeDeadlineAlert"
                                    id="DaysBeforeDeadline_alert"
                                    type="number"
                                    min="0"
                                    max="999"
                                    class="form-control wk-sg__input-number"
                                    (input)="numberInput($event)"
                                    (blur)="checkValidation()"
                                />

                                @if (groupSettingForm.controls.DaysBeforeDeadlineAlert.invalid) {
                                    <tooltip-pds3
                                        elementId="NumberOfDaysWarningShouldGreate_alert"
                                        mode="description"
                                        [openDelay]="250"
                                        [closeDelay]="250"
                                        position="left"
                                        targetSelector="#DaysBeforeDeadline_alert"
                                        class="danger"
                                    >
                                        {{ "Settings.NumberOfDaysWarningShouldGreate" | translate }}
                                    </tooltip-pds3>
                                }
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            @if (isJobsBillingDashboard === false) {
                <div class="wk-sg__section">
                    <div class="wk-sg__title">{{ "Settings.OptionsTitle" | translate }}</div>
                    <div class="wk-sg__section-container">
                        <div class="wk-sg__section-container__inputs">
                            <div class="wk-sg__section-container__inputs-title">{{ "Settings.OneCardDisplayedPer_New" | translate }}</div>
                            <div class="wk-sg__section-container__inputs-list">
                                <div class="wk-sg__input">
                                    <radio-field-pds3
                                        labelFor="lbl_DisplayGroupedCards"
                                        size="extra-small"
                                        isHorizontal="true"
                                        [label]="'Settings.ClientFile_New' | translate"
                                    >
                                        <input
                                            name="DisplayGroupedCards"
                                            type="radio"
                                            formControlName="DisplayGroupedCards"
                                            [value]="true"
                                            id="lbl_DisplayGroupedCards"
                                        />
                                    </radio-field-pds3>
                                </div>

                                <div class="wk-sg__input">
                                    <radio-field-pds3
                                        labelFor="lbl_DisplayGroupedCardsTaxpayer"
                                        size="extra-small"
                                        isHorizontal="true"
                                        [label]="'Settings.Taxpayer' | translate"
                                    >
                                        <input
                                            name="DisplayGroupedCards"
                                            type="radio"
                                            formControlName="DisplayGroupedCards"
                                            [value]="false"
                                            id="lbl_DisplayGroupedCardsTaxpayer"
                                        />
                                    </radio-field-pds3>
                                </div>
                            </div>
                        </div>

                        <div class="wk-sg__section-container__inputs">
                            <div class="wk-sg__section-container__inputs-title">
                                {{ "Settings.CardCategoryDisplayPreference.Title" | translate }}
                            </div>
                            <div>
                                <div class="wk-sg__input">
                                    <radio-field-pds3
                                        labelFor="lbl_CardCategoryDisplayPreference_MainTaxpayer"
                                        size="extra-small"
                                        isHorizontal="true"
                                        [label]="'Settings.CardCategoryDisplayPreference.MainTaxpayerCategory' | translate"
                                    >
                                        <input
                                            name="CardCategoryDisplayPreference"
                                            type="radio"
                                            formControlName="CardCategoryDisplayPreference"
                                            [value]="CardCategoryDisplayPreferenceValues.MainTaxpayer"
                                            id="lbl_CardCategoryDisplayPreference_MainTaxpayer"
                                        />
                                    </radio-field-pds3>
                                </div>

                                <div class="wk-sg__input">
                                    <radio-field-pds3
                                        labelFor="lbl_CardCategoryDisplayPreference_MostComplex"
                                        size="extra-small"
                                        isHorizontal="true"
                                        [label]="'Settings.CardCategoryDisplayPreference.MostComplexCategory' | translate"
                                    >
                                        <input
                                            class="form-check-input"
                                            name="CardCategoryDisplayPreference"
                                            type="radio"
                                            formControlName="CardCategoryDisplayPreference"
                                            [value]="CardCategoryDisplayPreferenceValues.MostComplex"
                                            id="lbl_CardCategoryDisplayPreference_MostComplex"
                                        />
                                    </radio-field-pds3>
                                </div>
                            </div>
                        </div>

                        <div class="wk-sg__section-container__inputs">
                            <div class="wk-sg__section-container__inputs-title">{{ "Settings.DisplayCardBasedOn.Title" | translate }}</div>
                            <div>
                                <div class="wk-sg__input">
                                    <radio-field-pds3
                                        labelFor="lbl_DisplayCardBasedOn_MainTaxpayer"
                                        size="extra-small"
                                        isHorizontal="true"
                                        [label]="'Settings.DisplayCardBasedOn.MainTaxpayerReturnStatusLabel' | translate"
                                    >
                                        <input
                                            class="form-check-input"
                                            name="DisplayCardBasedOn"
                                            type="radio"
                                            formControlName="DisplayCardBasedOn"
                                            [value]="DisplayCardBasedOnValues.MainTaxpayer"
                                            id="lbl_DisplayCardBasedOn_MainTaxpayer"
                                        />
                                    </radio-field-pds3>
                                </div>

                                <div class="wk-sg__input">
                                    <radio-field-pds3
                                        labelFor="lbl_DisplayCardBasedOn_LeastAdvanced"
                                        size="extra-small"
                                        isHorizontal="true"
                                        [label]="'Settings.DisplayCardBasedOn.LeastAdvancedReturnStatusLabel' | translate"
                                    >
                                        <input
                                            class="form-check-input"
                                            name="DisplayCardBasedOn"
                                            type="radio"
                                            formControlName="DisplayCardBasedOn"
                                            [value]="DisplayCardBasedOnValues.LeastAdvanced"
                                            id="lbl_DisplayCardBasedOn_LeastAdvanced"
                                        />
                                    </radio-field-pds3>
                                </div>
                            </div>
                        </div>
                        @if (isTaxprepDashboard === true) {
                            <div class="wk-sg__section-container__inputs">
                                <div class="wk-sg__section-container__inputs-title">{{ "Settings.ClientCodeDisplayInCards" | translate }}</div>
                                <div>
                                    <div class="wk-sg__input">
                                        <radio-field-pds3
                                            labelFor="lbl_ClientCodeId"
                                            size="extra-small"
                                            isHorizontal="true"
                                            [label]="'Settings.ClientCodeId' | translate"
                                        >
                                            <input
                                                class="form-check-input"
                                                name="ClientCode"
                                                type="radio"
                                                formControlName="ClientCode"
                                                [value]="'clientCodeId'"
                                                id="lbl_ClientCodeId"
                                            />
                                        </radio-field-pds3>
                                    </div>

                                    <div class="wk-sg__input">
                                        <radio-field-pds3
                                            labelFor="lbl_ClientCode"
                                            size="extra-small"
                                            isHorizontal="true"
                                            [label]="'Settings.ClientCodePin' | translate"
                                        >
                                            <input
                                                class="form-check-input"
                                                name="ClientCode"
                                                type="radio"
                                                formControlName="ClientCode"
                                                [value]="'clientCodePIN'"
                                                id="lbl_ClientCode"
                                            />
                                        </radio-field-pds3>
                                    </div>

                                    <div class="wk-sg__input">
                                        <radio-field-pds3
                                            labelFor="lbl_ClientCodeiFirm"
                                            size="extra-small"
                                            isHorizontal="true"
                                            [label]="'Settings.ClientCodeiFirm' | translate"
                                        >
                                            <input
                                                class="form-check-input"
                                                name="ClientCode"
                                                type="radio"
                                                formControlName="ClientCode"
                                                [value]="'clientCodeiFirm'"
                                                id="lbl_ClientCodeiFirm"
                                            />
                                        </radio-field-pds3>
                                    </div>
                                </div>
                            </div>
                        }
                        <div class="wk-sg__section-container__inputs">
                            <div class="wk-sg__section-container__inputs-title">{{ "Settings.ApplyToAll_New" | translate }}</div>
                            <div>
                                <div class="wk-sg__input">
                                    <checkbox-field-pds3
                                        labelFor="return_status"
                                        size="extra-small"
                                        label="{{ 'Settings.ReturnStatus' | translate }}"
                                    >
                                        <input
                                            type="checkbox"
                                            id="return_status"
                                            name="return_status"
                                            value="true"
                                            formControlName="ReturnStatusDefaultValue"
                                        />
                                    </checkbox-field-pds3>
                                </div>

                                <div class="wk-sg__input">
                                    <checkbox-field-pds3
                                        labelFor="assigned_status"
                                        size="extra-small"
                                        label="{{ 'Settings.AssignedToSection' | translate }}"
                                    >
                                        <input
                                            type="checkbox"
                                            id="assigned_status"
                                            name="assigned_status"
                                            value="true"
                                            formControlName="AssignedStatusDefaultValue"
                                        />
                                    </checkbox-field-pds3>
                                </div>
                            </div>
                        </div>
                        @if (isTaxprepDashboard === true) {
                            <div class="wk-sg__section-container__inputs">
                                <div class="wk-sg__section-container__inputs-title">
                                    {{ "Settings.DisplayClientFileInfoInTaxprep_New" | translate }}
                                </div>
                                <div>
                                    <div class="wk-sg__input">
                                        <checkbox-field-pds3
                                            labelFor="automatic_sync_open"
                                            size="extra-small"
                                            label="{{ 'Settings.WhenOpeningAFile_New' | translate }}"
                                        >
                                            <input
                                                type="checkbox"
                                                id="automatic_sync_open"
                                                name="automatic_sync_open"
                                                value="true"
                                                formControlName="AutomaticSyncOpen"
                                            />
                                        </checkbox-field-pds3>
                                    </div>
                                    <div class="wk-sg__input">
                                        <checkbox-field-pds3
                                            labelFor="automatic_sync_close"
                                            size="extra-small"
                                            label="{{ 'Settings.WhenClosingAFile_New' | translate }}"
                                        >
                                            <input
                                                type="checkbox"
                                                id="automatic_sync_close"
                                                name="automatic_sync_close"
                                                value="true"
                                                formControlName="AutomaticSyncClose"
                                            />
                                        </checkbox-field-pds3>
                                    </div>
                                </div>
                            </div>
                        }
                    </div>
                </div>
            }
        </form>
    </div>
}

<div class="wk-sg__actions">
    <button
        class="btn-primary wk-sg__actions-save"
        (click)="submitForm($event)"
        [disabled]="
            groupSettingForm.controls.DaysInStepWarning.invalid ||
            groupSettingForm.controls.DaysInStepAlert.invalid ||
            groupSettingForm.controls.DaysBeforeDeadlineWarning.invalid ||
            groupSettingForm.controls.DaysBeforeDeadlineAlert.invalid ||
            groupSettingForm.pristine ||
            loading
        "
    >
        @if (loading) {
            <app-loader [isOverlay]="false" size="button" />
        }
        {{ "Settings.Save" | translate }}
    </button>
    <button class="btn-secondary wk-sg__actions-cancel" (click)="cancelForm()">
        {{ "General.Close" | translate }}
    </button>
</div>

<div kendoDialogContainer></div>
